import axiosInstance from '../../utils/axios-instance';
import { actionCreator, createRequestTypes } from '../../utils/helpers';

export const GET_ACCOUNT_JOURNAL = createRequestTypes('GET_ACCOUNT_JOURNAL');
export const GET_ACCOUNT_JOURNAL_SUMMARY = createRequestTypes('GET_ACCOUNT_JOURNAL_SUMMARY');



export const getAccountJournalAction = (accountId) => async (dispatch) => {
  dispatch(actionCreator.request(GET_ACCOUNT_JOURNAL));
  try {
    const response = await axiosInstance.get(`/account/${accountId}/journal`);
    dispatch(actionCreator.success(GET_ACCOUNT_JOURNAL, response.data));
  } catch (err) {
    dispatch(actionCreator.failure(GET_ACCOUNT_JOURNAL));
  }
};


export const getAccountJournalSummaryAction = (accountId) => async (dispatch) => {
  dispatch(actionCreator.request(GET_ACCOUNT_JOURNAL_SUMMARY));
  try {
    const response = await axiosInstance.get(`/account/${accountId}/journal/summary`);
    dispatch(actionCreator.success(GET_ACCOUNT_JOURNAL_SUMMARY, response.data));
  } catch (err) {
    dispatch(actionCreator.failure(GET_ACCOUNT_JOURNAL_SUMMARY));
  }
};
